import { useState } from "react";
import { Col, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Href } from "../../../../constants";
import { ClothDetailsList, ClothDetailsData } from "../../../../data/applications/ECommerce";

// A component that displays the details of the clothing product in a tab layout.
const ClothDetails = () => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <Col sm="12">
      <Nav tabs pills className="nav-primary mb-0">
        {ClothDetailsList.map((data, index) => (
          <NavItem key={index}>
            <NavLink href={Href} className={activeTab === index + 1 ? "active" : ""} onClick={() => setActiveTab(index + 1)}>
              {data}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={activeTab}>
        {ClothDetailsData.map((desc, index) => (
          <TabPane tabId={index + 1} key={index}>
            {desc.map((text, idx) => (
              <p className={`mb-0 ${idx === 0 ? "m-t-20" : ""}`} dangerouslySetInnerHTML={{ __html: text }} key={idx} />
            ))}
          </TabPane>
        ))}
      </TabContent>
    </Col>
  );
};

export default ClothDetails;